export enum RewardProvider {
  TwoReward = "TwoReward",
  PJM = "PJM"
}

export enum CouponCodeItemStatus {
  Cancelled = "Cancelled",
  Expired = "Expired",
  Issued = "Issued",
  Redeemed = "Redeemed"
}
